import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import Logo from "../../assets/images/showtime_logo.png";
import SHTText from "../../components/SHTText";
import { useForm, Controller } from "react-hook-form";
import "../../assets/styles/page/first_form_style.css";
import SHTInput from "../../components/SHTInput";
import SHTButton from "../../components/SHTButton";
import { EMAIL_INPUT_VALIDATION } from "../../utils/validation";
import { RequestResponseInterface } from "../../interfaces/axios.dto";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useParams } from "react-router-dom";

interface FormInputs {
  email: string;
}

function ForgotPassword({ forgotPassword }: any) {
  const navigate = useNavigate();

  const [registrationSuccessful, setRegistrationSuccessful] =
    useState("not sent");

  const [loading, setLoading] = useState(false);

  let registerInput: FormInputs = {
    email: "",
  };

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: registerInput,
  });

  const handleSubmitData = async (data: any) => {
    setLoading(true);
    await forgotPassword(data)
      .then((response: RequestResponseInterface) => {
        if (response.status === 200) {
          setLoading(false);

          toast.success("Password reset email sent successful");
          setRegistrationSuccessful("sent");
        } else {
          toast.error("This email has been doesnt exist");
        }
        setLoading(false);
      })
      .catch((err: any) => {
        toast.error("Error occurred");
        setLoading(false);
      });
  };

  return (
    <div>
      <section className="register_team_container">
        <Container>
          <section
            className="register_form_container"
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <main className="register_form ">
              <section className="first_form_container">
                <div style={{ textAlign: "center" }}>
                  <img
                    src={Logo}
                    style={{ width: 100, height: 60, marginBottom: 10 }}
                    alt="Logo"
                  />
                </div>
                {registrationSuccessful === "sent" && (
                  <div>
                    <div className="m-3" style={{ textAlign: "center" }}>
                      <SHTText
                        size="p"
                        text="A link has been sent to your email address, click on it to reset your password. "
                        color="gray"
                      />
                    </div>
                  </div>
                )}

                {registrationSuccessful === "not sent" && (
                  <div>
                    <div className="m-3" style={{ textAlign: "center" }}>
                      <SHTText
                        size="p"
                        text="Enter your email address you used in registering to change your password "
                        color="gray"
                      />
                    </div>
                    <div className="form_element">
                      <Controller
                        control={control}
                        name="email"
                        rules={EMAIL_INPUT_VALIDATION}
                        render={({ field: { value, onChange } }) => (
                          <SHTInput
                            label="Email"
                            placeholder=""
                            type="messageText"
                            value={value}
                            // editable={loading}
                            onChangeText={onChange}
                            error={errors.email && errors.email.message}
                          />
                        )}
                      />
                    </div>

                    <section className="d-flex justify-content-between align-items-center">
                      <SHTButton
                        type="submit"
                        name="Submit"
                        loading={loading}
                        handleClick={handleSubmit(handleSubmitData)}
                      />
                    </section>
                  </div>
                )}
              </section>
            </main>
          </section>
        </Container>
      </section>
    </div>
  );
}

const mapStateToProps = ({}: any) => ({});

export default connect(mapStateToProps, actions)(ForgotPassword);
